import { registerPlugin, PluginListenerHandle } from "@capacitor/core";

export interface ProximityPlugin {
  keepAwake(): Promise<void>;
  allowSleep(): Promise<void>;
  startMonitoring(): Promise<void>;
  stopMonitoring(): Promise<void>;
  wakeScreen(): Promise<void>;
  dimScreen(): Promise<void>;
  addListener(
    eventName: "personNearby",
    listener: (data: { trigger?: string; distance?: number }) => void,
  ): Promise<PluginListenerHandle>;
}

export const Proximity = registerPlugin<ProximityPlugin>("Proximity");
